import Vue from "vue";
import Router from "vue-router";
import axios from "axios";
import Home from "./module/layout/index.vue";
import Schedule from "./module/schedule/index.vue";
import Report from "./module/report/index.vue";
import Patient from "./module/patient/index.vue";
import Client from "./module/client/index.vue";
import Contact from "./module/contact/index.vue";
import Inventory from "./module/inventory/index.vue";
import Billing from "./module/billing/index.vue";
import Settings from "./module/settings/index.vue";
import SettingsCI from "./module/settings/settings-ci.vue";
import ReportCI from "./module/report/report-ci.vue";
import Penyu from "./module/penyu/index.vue";
import Boarding from "./module/schedule/boarding/index.vue";
import BoardingReservations from "./module/schedule/boarding/reservations.vue";
import BoardingDashboard from "./module/schedule/boarding/dashboard.vue";
import Business from "./module/business/index.vue";
import TEMPLATES from "@/constants/templates";
import { includes } from "lodash";

Vue.use(Router);

const MISMATCH_MESSAGE =
    "We have detected that your current clinic does not match the clinic associated with your active session. Click OK to refresh the page.";

const template_available = Object.values(TEMPLATES.LIST).map(
    type => type.route
);

const checkAccessSchedule = (permissions, currentActor, to) => {
    // Super admin always authorize
    if (currentActor.issuper == true || permissions.issuper) {
        return true;
    }

    // FROM / OR APPS, WILL CHECK WHETHER THE (TO) PAGE IS AUTHORIZE
    // IF NOT, WILL REDIRECT TO CORRECT PAGE BASED ON PERMISSION
    let isPass = true;
    if (to.matched && to.matched.length > 0) {
        let target = null;
        let passChild = [];
        let moduleName = to.matched[to.matched.length - 1].parent.name;

        switch (moduleName) {
            case "appointment":
                isPass = permissions["schedule.access"];
                break;
            case "patient":
                isPass = permissions["patient.access"];
                break;
            case "client":
                isPass = permissions["client.access"];
                break;
            case "contact":
                isPass = permissions["contact.access"];
                break;
            case "inventory":
                isPass = permissions["inventory.access"];
                break;
            case "billing":
                target = `billing.${to.name}`;
                passChild = ["billing.invoice", "billing.estimate"]; // as of now only estimate and invoice will bypass parent permission except for return due to not receiving any complaint from clinic
                isPass =
                    permissions["billing.access"] ||
                    includes(passChild, target);
                break;
            case "report":
                if (to.path == "/report/reminder") {
                    // report reminder
                    isPass =
                        permissions["schedule.reminder.access"] &&
                        permissions["schedule.access"];
                } else {
                    // other report
                    isPass = permissions["report.access"];
                }
                break;
            case "settings":
                if (to.name == "stafflist") {
                    isPass =
                        permissions["setting.staff.view"] &&
                        permissions["setting.access"];
                } else if (to.name == "address") {
                    isPass =
                        (permissions["setting.address.add"] ||
                            permissions["setting.address.edit"] ||
                            permissions["setting.address.delete"]) &&
                        permissions["setting.access"];
                } else if (
                    ["template_list", "template_details"].includes(to.name)
                ) {
                    isPass = permissions["setting.access"];
                } else if (to.name == "cubex") {
                    isPass =
                        permissions["setting.extension.update"] &&
                        permissions["setting.access"];
                }
                break;
            case "stafflist":
                if (to.name == "staff_view") {
                    isPass =
                        permissions["setting.staff.view"] &&
                        permissions["setting.access"];
                }
                break;
            default:
                isPass = true;
                break;
        }

        // schedule alone has multiple modules.
        // need to be handled properly because of nested routes and specific permissions.
        switch (to.path) {
            case "/schedule/appointment":
            case "/schedule/census":
            case "/schedule/tasks":
                isPass = permissions["schedule.access"];
                break;

            case "/schedule/treatment":
                isPass =
                    permissions["schedule.access"] &&
                    permissions["schedule.treatmentboard.view"] &&
                    permissions["schedule.boarding.access"];
                break;

            case "/schedule/boarding/dashboard":
            case "/schedule/boarding/reservations":
                isPass =
                    permissions["schedule.access"] &&
                    permissions["schedule.boarding.access"];
                break;

            case "/schedule/inbox":
                isPass =
                    permissions["schedule.access"] &&
                    permissions["schedule.conversation.view"];
                break;
        }
    }

    if (isPass) {
        return true;
    }

    // The redirection page
    if (permissions["schedule.access"]) {
        return "schedule";
    } else if (permissions["patient.access"]) {
        return "patient";
    } else if (permissions["client.access"]) {
        return "client";
    } else if (permissions["contact.access"]) {
        return "contact";
    } else if (permissions["inventory.access"]) {
        return "inventory";
    } else if (permissions["billing.access"]) {
        return "billing";
    } else if (permissions["report.access"]) {
        return "report";
    } else if (permissions["setting.access"]) {
        return "settings";
    }
    return false;
};

let hasRedirect = false;

let urlLogoutSessionError =
    process.env.APPS + "index.php/welcome/logout?f=3&error=Session%20error";

const beforeEnter = async (to, from, next) => {
    let identifier = to.params.token
        ? to.params.token
        : localStorage.getItem("Vetter-Token");
    axios.defaults.headers.common["Vetter-Token"] = identifier;
    axios.defaults.headers.common["x-requested-with"] = "XMLHttpRequest";

    if (!identifier) {
        if (window.location.port !== "8080") {
            setTimeout(function () {
                if (typeof newrelic !== "undefined") {
                    // eslint-disable-next-line no-undef
                    newrelic.addPageAction("view-logout", { reason: "token" });
                }
                window.location =
                    process.env.APPS + "index.php/welcome/logout?f=3";
            }, 1000);
        } else {
            localStorage.setItem("Vetter-Token", process.env.VETTER_TOKEN);
            document.location.reload();
        }
    }

    // Axios interceptors
    axios.interceptors.response.use(
        null,
        _.debounce(error => {
            if (error.response && error.response.status === 401) {
                // localStorage.removeItem("Vetter-Token");
                setTimeout(function () {
                    if (typeof newrelic !== "undefined") {
                        // eslint-disable-next-line no-undef
                        newrelic.addPageAction("view-logout", {
                            reason: "session"
                        });
                    }
                    window.location = urlLogoutSessionError;
                }, 1000);
            }

            if (error.response && error.response.status === 419) {
                alert(MISMATCH_MESSAGE);
                window.location.reload();
            }

            return Promise.reject(error);
        }, 5000)
    );

    $(document).ajaxError(function (event, request) {
        if (request.status === 401) {
            //timeout
            setTimeout(function () {
                if (window.location.port !== "8080") {
                    if (typeof newrelic !== "undefined") {
                        // eslint-disable-next-line no-undef
                        newrelic.addPageAction("view-logout", {
                            reason: "session"
                        });
                    }
                    window.location = urlLogoutSessionError;
                }
            }, 1000);
        }

        if (request.status === 419) {
            alert(MISMATCH_MESSAGE);
            window.location.reload();
        }
    });

    // run once for route /
    if (from.fullPath == "/" && !hasRedirect) {
        const redirect = await Promise.all([
            axios.get(process.env.ACTOR_SERVICE + "staff/current/permissions"),
            axios.get(process.env.ACTOR_SERVICE + "staff/current")
        ]).then(response => {
            const permissions = response[0].data.response.resource;
            const currentActor = response[1].data.response.resource.actor;
            return checkAccessSchedule(permissions, currentActor, to);
        });

        hasRedirect = true;
        if (redirect == false) {
            if (typeof newrelic !== "undefined") {
                // eslint-disable-next-line no-undef
                newrelic.addPageAction("view-logout", { reason: "redirect" });
            }
            window.location = process.env.APPS + "index.php/welcome/logout?f=3";
            return;
        } else if (redirect == "settings") {
            window.location = process.env.APPS + "business/business";
            return;
        } else if (redirect != true) {
            next({
                name: redirect
            });
            return;
        }
    }

    next();
};

const router = new Router({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [
        {
            path: "/",
            name: "home",
            component: Home,
            redirect: {
                name: "appointment"
            },
            beforeEnter,
            props: true,
            children: [
                {
                    path: "schedule",
                    name: "schedule",
                    component: Schedule,
                    redirect: {
                        name: "appointment"
                    },
                    children: [
                        {
                            path: "appointment/:view?/:start?/:id?",
                            name: "appointment",
                            component: () =>
                                import(
                                    /* webpackChunkName: "appointment" */ "./module/schedule/appointment/index.vue"
                                ),
                            meta: {
                                title: "Schedule"
                            }
                        },
                        {
                            path: "inbox",
                            name: "inbox",
                            component: () =>
                                import(
                                    /* webpackChunkName: "inbox" */ "./module/inbox/index.vue"
                                ),
                            meta: {
                                title: "Inbox"
                            }
                        },
                        {
                            path: "treatment",
                            name: "treatment",
                            component: () =>
                                import(
                                    /* webpackChunkName: "treatment" */ "./module/schedule/treatment-board/index.vue"
                                ),
                            meta: {
                                title: "Treatment Board"
                            },
                            children: [
                                {
                                    path: ":treatmentId/:id",
                                    name: "treatment.patient",
                                    component: () =>
                                        import(
                                            /* webpackChunkName: "treatment" */ "./module/schedule/treatment-board/index.vue"
                                        ),
                                    meta: {
                                        title: "Treatment Board"
                                    }
                                },
                                {
                                    path: "activity",
                                    name: "treatment.activity",
                                    component: () =>
                                        import(
                                            /* webpackChunkName: "treatment" */ "./module/schedule/treatment-board/activity.vue"
                                        ),
                                    meta: {
                                        title: "Treatment Board"
                                    }
                                },
                                {
                                    path: "treatment-bundle",
                                    name: "treatment.bundle",
                                    component: () =>
                                        import(
                                            /* webpackChunkName: "treatment" */ "./module/schedule/treatment-board/treatment-bundle.vue"
                                        ),
                                    meta: {
                                        title: "Treatment Board"
                                    }
                                },
                                {
                                    path: "admit",
                                    name: "treatment.admit",
                                    component: () =>
                                        import(
                                            /* webpackChunkName: "treatment" */ "./module/schedule/treatment-board/admit.vue"
                                        ),
                                    meta: {
                                        title: "Treatment Board"
                                    }
                                }
                            ]
                        },
                        {
                            path: "tasks",
                            name: "tasks",
                            component: () =>
                                import(
                                    /* webpackChunkName: "task" */ "./module/schedule/task/index.vue"
                                )
                        },
                        {
                            path: "census",
                            name: "census",
                            component: () =>
                                import(
                                    /* webpackChunkName: "task" */ "./module/schedule/census/index.vue"
                                )
                        },
                        {
                            path: "boarding",
                            name: "boarding",
                            component: Boarding,
                            children: [
                                {
                                    path: "dashboard",
                                    name: "boarding.dashboard",
                                    component: BoardingDashboard
                                },
                                {
                                    path: "reservations",
                                    name: "boarding.reservations",
                                    component: BoardingReservations
                                }
                            ]
                        }
                    ]
                },
                {
                    path: "patient",
                    name: "patient",
                    component: Patient,
                    redirect: {
                        name: "patient_dashboard"
                    },
                    children: [
                        {
                            name: "patient_dashboard",
                            path: "dashboard",
                            component: () =>
                                import(
                                    /* webpackChunkName: "patient" */ "./module/patient/dashboard.vue"
                                ),
                            meta: {
                                title: "Patient Dashboard"
                            }
                        },
                        {
                            path: "profile/:id",
                            name: "patient_profile",
                            component: () =>
                                import(
                                    /* webpackChunkName: "patient" */ "./module/patient/profile.vue"
                                )
                            // meta: {
                            //     title: "Patient Profile"
                            // }
                        },
                        {
                            path: "annotate/:id",
                            name: "patient_image_annotate",
                            component: () =>
                                import(
                                    /* webpackChunkName: "patient" */ "./module/patient/annotate.vue"
                                ),
                            meta: {
                                title: "Patient Profile"
                            }
                        },
                        {
                            path: "letter/:id",
                            name: "letter",
                            component: () =>
                                import(
                                    /* webpackChunkName: "patient" */ "./module/patient/letter.vue"
                                )
                        },
                        {
                            path: "lab/:id",
                            name: "lab",
                            component: () =>
                                import(
                                    /* webpackChunkName: "patient" */ "./module/patient/lab.vue"
                                )
                        },
                        {
                            path: "form/:id",
                            name: "patient_webform",
                            component: () =>
                                import(
                                    /* webpackChunkName: "patient" */ "./components/webform/webform.vue"
                                )
                        },
                        {
                            path: "soap/:id",
                            name: "soap",
                            component: () =>
                                import(
                                    /* webpackChunkName: "patient" */ "./module/patient/soap.vue"
                                )
                        },
                        {
                            path: "lab-results",
                            name: "lab_results",
                            component: () =>
                                import(
                                    /* webpackChunkName: "patient-lab-results" */ "./module/patient/lab-results/index.vue"
                                )
                        }
                    ]
                },
                {
                    path: "client",
                    name: "client",
                    component: Client,
                    redirect: {
                        name: "client_dashboard"
                    },
                    children: [
                        {
                            path: "dashboard",
                            name: "client_dashboard",
                            component: () =>
                                import(
                                    /* webpackChunkName: "client" */ "./module/client/dashboard.vue"
                                ),
                            meta: {
                                title: "Client Dashboard"
                            }
                        },
                        {
                            path: "profile/:id",
                            name: "client_profile",
                            component: () =>
                                import(
                                    /* webpackChunkName: "client" */ "./module/client/profile.vue"
                                )
                            // meta: {
                            //     title: "Client Profile"
                            // }
                        },
                        {
                            path: "new",
                            name: "client_new",
                            component: () =>
                                import(
                                    /* webpackChunkName: "client" */ "./module/client/new.vue"
                                ),
                            meta: {
                                title: "New Client"
                            }
                        },
                        {
                            path: "letter/:id",
                            name: "client_letter",
                            component: () =>
                                import(
                                    /* webpackChunkName: "patient" */ "./module/patient/letter.vue"
                                )
                        },
                        {
                            path: "form/:id",
                            name: "client_webform",
                            component: () =>
                                import(
                                    /* webpackChunkName: "client" */ "./components/webform/webform.vue"
                                )
                        }
                    ]
                },
                {
                    path: "contact",
                    name: "contact",
                    component: Contact,
                    redirect: {
                        name: "contact_dashboard"
                    },
                    children: [
                        {
                            path: "dashboard",
                            name: "contact_dashboard",
                            component: () =>
                                import(
                                    /* webpackChunkName: "contact" */ "./module/contact/dashboard.vue"
                                ),
                            meta: {
                                title: "Contact Dashboard"
                            }
                        },
                        {
                            path: "profile/:id",
                            name: "contact_actor",
                            component: () =>
                                import(
                                    /* webpackChunkName: "contact" */ "./module/contact/profile.vue"
                                )
                        },
                        {
                            path: "company/:id",
                            name: "contact_company",
                            component: () =>
                                import(
                                    /* webpackChunkName: "contact" */ "./module/contact/profile.vue"
                                )
                        }
                    ]
                },
                {
                    path: "inventory",
                    name: "inventory",
                    component: Inventory,
                    redirect: {
                        name: "inventory_dashboard"
                    },
                    children: [
                        {
                            name: "inventory_dashboard",
                            path: "dashboard",
                            component: () =>
                                import(
                                    /* webpackChunkName: "inventory" */ "./module/inventory/dashboard.vue"
                                ),
                            meta: {
                                title: "Inventory Dashboard"
                            }
                        },
                        {
                            path: "item-new",
                            name: "item_new",
                            component: () =>
                                import(
                                    /* webpackChunkName: "inventory" */ "./module/inventory/item-new.vue"
                                )
                        },
                        {
                            path: "item/:id",
                            name: "item",
                            component: () =>
                                import(
                                    /* webpackChunkName: "inventory" */ "./module/inventory/item.vue"
                                )
                        },
                        {
                            path: "purchase-order/:id",
                            name: "purchase_order",
                            component: () =>
                                import(
                                    /* webpackChunkName: "inventory" */ "./module/inventory/purchase-order/main.vue"
                                )
                        },
                        {
                            path: "receipt/:id",
                            name: "receipt",
                            component: () =>
                                import(
                                    /* webpackChunkName: "inventory" */ "./module/inventory/receipt/main.vue"
                                )
                        }
                    ]
                },
                {
                    path: "billing",
                    name: "billing",
                    component: Billing,
                    redirect: {
                        name: "billing_dashboard"
                    },
                    children: [
                        {
                            name: "billing_dashboard",
                            path: "dashboard",
                            component: () =>
                                import(
                                    /* webpackChunkName: "billing" */ "./module/billing/dashboard.vue"
                                ),
                            meta: {
                                title: "Billing Dashboard"
                            }
                        },
                        {
                            path: "invoice/:id",
                            name: "invoice",
                            component: () =>
                                import(
                                    /* webpackChunkName: "billing" */ "./module/billing/invoice.vue"
                                )
                        },
                        {
                            path: "estimate/:id",
                            name: "estimate",
                            component: () =>
                                import(
                                    /* webpackChunkName: "billing" */ "./module/billing/estimate.vue"
                                )
                        },
                        {
                            name: "return",
                            path: "return/:id",
                            component: () =>
                                import(
                                    /* webpackChunkName: "billing" */ "./module/billing/return.vue"
                                )
                        }
                    ]
                },
                {
                    path: "report/scheduled/:id?",
                    name: "report_scheduled_form",
                    component: () =>
                        import(
                            /* webpackChunkName: "report" */ "./module/report/scheduled/index.vue"
                        )
                },
                {
                    path: "report",
                    name: "report",
                    component: Report,
                    redirect: {
                        name: "report_dashboard"
                    },
                    children: [
                        {
                            path: "dashboard",
                            name: "report_dashboard",
                            component: () =>
                                import(
                                    /* webpackChunkName: "report" */ "./module/report/dashboard.vue"
                                ),
                            meta: {
                                title: "Report Dashboard"
                            }
                        },
                        {
                            path: ":id",
                            name: "report_detail",
                            component: () =>
                                import(
                                    /* webpackChunkName: "report" */ "./module/report/detail.vue"
                                )
                        },
                        {
                            path: "custom/:id",
                            name: "custom_report",
                            component: () =>
                                import(
                                    /* webpackChunkName: "report" */ "./module/report/detail.vue"
                                )
                        }
                    ]
                },
                /** Page Templates
                 ** Description : Contains templates for dev's reference. Not for users
                 ** Restriction : Link/Navigation for this page is not to be shared anywhere
                 */
                {
                    path: "penyu",
                    name: "penyu",
                    component: Penyu,
                    redirect: {
                        name: "penyu_dashboard"
                    },
                    children: [
                        {
                            path: "",
                            name: "penyu_dashboard",
                            component: () =>
                                import(
                                    /* webpackChunkName: "penyu" */ "./module/penyu/main.vue"
                                ),
                            meta: {
                                title: "DSV Page Templates"
                            }
                        },
                        {
                            path: "page-left-nav",
                            name: "page_left_nav",
                            component: () =>
                                import(
                                    /* webpackChunkName: "penyu" */ "./module/penyu/page-left-nav.vue"
                                )
                        },
                        {
                            path: "page-list",
                            name: "page_list",
                            component: () =>
                                import(
                                    /* webpackChunkName: "penyu" */ "./module/penyu/page-list.vue"
                                )
                        }
                    ]
                },
                {
                    path: "settings",
                    name: "settings",
                    component: Settings,
                    children: [
                        {
                            path: "template/:type",
                            name: "template_list",
                            component: () =>
                                import(
                                    /* webpackChunkName: "settings" */ "./module/settings/template/list.vue"
                                )
                        },
                        {
                            path: "template/:type/:id",
                            name: "template_details",
                            component: () =>
                                import(
                                    /* webpackChunkName: "settings" */ "./module/settings/template/index.vue"
                                )
                        },
                        {
                            path: "payments",
                            name: "payments",
                            component: () =>
                                import(
                                    /* webpackChunkName: "settings" */ "./module/settings/payment/index.vue"
                                )
                        },
                        {
                            path: "permissions",
                            name: "permissions",
                            component: () =>
                                import(
                                    /* webpackChunkName: "settings" */ "./module/settings/permissions/index.vue"
                                )
                        },
                        {
                            path: "users",
                            name: "stafflist",
                            component: () =>
                                import(
                                    /* webpackChunkName: "settings" */ "./module/settings/staff/staff.vue"
                                ),
                            children: [
                                {
                                    path: "new",
                                    name: "staff_new",
                                    component: () =>
                                        import(
                                            /* webpackChunkName: "settings" */ "./module/settings/staff/new.vue"
                                        )
                                },
                                {
                                    path: "view/:id",
                                    name: "staff_view",
                                    component: () =>
                                        import(
                                            /* webpackChunkName: "settings" */ "./module/settings/staff/view.vue"
                                        )
                                }
                            ]
                        },
                        {
                            path: "petcare",
                            name: "petcare",
                            component: () =>
                                import(
                                    /* webpackChunkName: "settings" */ "./module/settings/petcare/index.vue"
                                )
                        },
                        {
                            path: "petcare-onboarding",
                            name: "petcare_onboarding",
                            component: () =>
                                import(
                                    /* webpackChunkName: "settings" */ "./module/settings/petcare/onboarding/index.vue"
                                )
                        },
                        {
                            path: "staff",
                            name: "staff_setting",
                            component: () =>
                                import(
                                    /* webpackChunkName: "settings" */ "./module/settings/staff/index.vue"
                                ),
                            children: [
                                {
                                    path: "profile/:id",
                                    name: "staff_profile",
                                    component: () =>
                                        import(
                                            /* webpackChunkName: "settings" */ "./module/settings/staff/profile.vue"
                                        ),
                                    children: [
                                        {
                                            path: "notifications",
                                            name: "notifications-setting",
                                            component: () =>
                                                import(
                                                    /* webpackChunkName: "settings" */ "./module/settings/notification/staff-settings.vue"
                                                )
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            path: "address",
                            name: "address",
                            component: () =>
                                import(
                                    /* webpackChunkName: "settings" */ "./module/settings/address/index.vue"
                                )
                        },
                        {
                            path: "configurations/global-notification",
                            name: "global-notification-setting",
                            component: () =>
                                import(
                                    /* webpackChunkName: "settings" */ "./module/settings/notification/global-settings.vue"
                                )
                        },
                        {
                            path: "subscriptions",
                            name: "subscriptions",
                            component: () =>
                                import(
                                    /* webpackChunkName: "settings" */ "./module/settings/subscription/index.vue"
                                )
                        },
                        {
                            path: "clinic-hours",
                            name: "clinic-hours",
                            component: () =>
                                import(
                                    /* webpackChunkName: "settings" */ "./module/settings/clinic-hours/index.vue"
                                )
                        },
                        {
                            path: "hours",
                            name: "hours",
                            component: () =>
                                import(
                                    /* webpackChunkName: "settings" */ "./module/settings/clinic-hours-v2/index.vue"
                                )
                        },
                        {
                            path: "cubex",
                            name: "cubex",
                            component: () =>
                                import(
                                    /* webpackChunkName: "settings" */ "./module/settings/cubex/index.vue"
                                ),
                            meta: {
                                title: "Cubex Integration"
                            }
                        },
                        {
                            path: "appointment-types",
                            name: "appointment_types",
                            component: () =>
                                import(
                                    /* webpackChunkName: "settings" */ "./module/settings/appointment-types/index.vue"
                                )
                        },
                        {
                            path: "discounts",
                            name: "discounts",
                            component: () =>
                                import(
                                    /* webpackChunkName: "settings" */ "./module/settings/discounts/index.vue"
                                )
                        },
                        {
                            path: "production-credits",
                            name: "production_credits",
                            component: () =>
                                import(
                                    /* webpackChunkName: "settings" */ "./module/settings/production-credits/index.vue"
                                )
                        },
                        {
                            path: "sms-defaults",
                            name: "sms-defaults",
                            component: () =>
                                import(
                                    /* webpackChunkName: "settings" */ "./module/settings/sms-defaults/index.vue"
                                )
                        },
                        {
                            path: "email-defaults",
                            name: "email_defaults",
                            component: () =>
                                import(
                                    /* webpackChunkName: "settings" */ "./module/settings/email-defaults/index.vue"
                                )
                        },
                        {
                            path: "devices",
                            name: "devices_list",
                            component: () =>
                                import(
                                    /* webpackChunkName: "settings" */ "./module/settings/devices-list/index.vue"
                                )
                        },
                        {
                            path: "printers",
                            name: "printers_list",
                            component: () =>
                                import(
                                    /* webpackChunkName: "settings" */ "./module/settings/printers-list/index.vue"
                                )
                        },
                        {
                            path: "taxes",
                            name: "taxes",
                            component: () =>
                                import(
                                    /* webpackChunkName: "settings" */ "./module/settings/taxes/index.vue"
                                )
                        },
                        {
                            path: "rooms",
                            name: "rooms_list",
                            component: () =>
                                import(
                                    /* webpackChunkName: "settings" */ "./module/settings/rooms/index.vue"
                                )
                        },
                    ]
                },
                {
                    path: "settings-ci",
                    name: "settings-ci",
                    component: SettingsCI
                },
                {
                    path: "report-ci/:id",
                    name: "report-ci",
                    component: ReportCI
                }
            ]
        },
        {
            path: "/display/:token",
            name: "display",
            beforeEnter,
            // route level code-splitting
            // this generates a separate chunk (display.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () =>
                import(
                    /* webpackChunkName: "display" */ "./module/layout/display.vue"
                ),
            children: [
                {
                    path: "schedule/treatment",
                    name: "display_treatment",
                    component: () =>
                        import(
                            /* webpackChunkName: "display" */ "./module/schedule/treatment-board/index.vue"
                        ),
                    meta: {
                        title: "Treatment Board"
                    }
                },
                {
                    path: "schedule/appointment",
                    name: "display_appointment",
                    component: () =>
                        import(
                            /* webpackChunkName: "display" */ "./module/schedule/appointment/index.vue"
                        ),
                    meta: {
                        title: "Appointment"
                    }
                },
                {
                    path: "schedule/census",
                    name: "display_census",
                    component: () =>
                        import(
                            /* webpackChunkName: "display" */ "./module/schedule/census/index.vue"
                        ),
                    meta: {
                        title: "Census"
                    }
                }
            ]
        },
        {
            path: "/auth/:path/:token",
            name: "auth",
            redirect(to) {
                if (to.params.path && to.params.token) {
                    axios.defaults.headers.common["Vetter-Token"] =
                        to.params.token;
                    return to.params.path;
                }
                return false;
            }
        },
        {
            path: "/reset-password",
            name: "reset-password",
            component: () =>
                import(
                    /* webpackChunkName: "auth" */ "./module/auth/reset-password.vue"
                )
        },

        {
            path: "/account-statement/:clientId",
            name: "account-statement",
            component: () =>
                import(
                    /* webpackChunkName: "account-statement" */ "./module/public/account-statement.vue"
                )
        },
        {
            path: "/online-invoice/:id",
            name: "online-invoice",
            component: () =>
                import(
                    /* webpackChunkName: "invoice-payment" */ "./module/public/invoice-payment.vue"
                )
        },
        {
            path: "/3d-secure-2/:id",
            name: "3d-secure-2",
            component: () =>
                import(
                    /* webpackChunkName: "3d-secure-2" */ "./module/layout/3d-secure-verify.vue"
                )
        },
        {
            path: "/checkin-forms/:id",
            name: "checkin-forms",
            component: () =>
                import(
                    /* webpackChunkName: "checkin-forms" */ "./module/public/checkin-webforms.vue"
                )
        },
        {
            path: "/online-form/:id",
            name: "online-form",
            component: () =>
                import(
                    /* webpackChunkName: "online-webform" */ "./module/public/online-webform.vue"
                )
        },
        {
            path: "/:encodedBusinessId",
            beforeEnter,
            component: Business,
            children: [
                {
                    path: "",
                    component: Home,
                    children: [
                        {
                            path: "patient",
                            name: "direct-url-patient",
                            component: Patient,
                            children: [
                                {
                                    path: ":index",
                                    name: "direct-url-patient-profile",
                                    component: () =>
                                        import(
                                            /* webpackChunkName: "patient" */ "./module/patient/profile.vue"
                                        )
                                }
                            ]
                        },
                        {
                            path: "client",
                            name: "direct-url-client",
                            component: Client,
                            children: [
                                {
                                    path: ":index",
                                    name: "direct-url-client-profile",
                                    component: () =>
                                        import(
                                            /* webpackChunkName: "patient" */ "./module/client/profile.vue"
                                        )
                                }
                            ]
                        },
                        {
                            path: "invoice",
                            name: "direct-url-billing-invoice",
                            component: Billing,
                            children: [
                                {
                                    path: ":index",
                                    name: "direct-url-billing-invoice-profile",
                                    component: () =>
                                        import(
                                            /* webpackChunkName: "billing" */ "./module/billing/invoice.vue"
                                        )
                                }
                            ]
                        },
                        {
                            path: "estimate",
                            name: "direct-url-billing-estimate",
                            component: Billing,
                            children: [
                                {
                                    path: ":index",
                                    name: "direct-url-billing-estimate-profile",
                                    component: () =>
                                        import(
                                            /* webpackChunkName: "billing" */ "./module/billing/estimate.vue"
                                        )
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            path: "*",
            redirect() {
                document.location = process.env.APPS + "404/";
            }
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    }
});

router.afterEach(to => {
    // Straight away close heartbeat loader if page is outside layout/index
    if (
        !(to.matched && to.matched.length > 0 && to.matched[0].name === "home")
    ) {
        let heartbeat = document.getElementById("the-heartbeat");
        if (heartbeat) {
            heartbeat.style.display = "none";
        }
    }
});

router.beforeEach(async (to, from, next) => {
    if (to.name == "patient_profile") {
        if (process.env.USE_PATIENT_MODULE_VUE === "false") {
            next(false);
            location.href =
                process.env.APPS + "patient/patient/view/" + to.params.id;
            return;
        }
    } else if (
        to.name === "template_list" &&
        !template_available.includes(to.params.type)
    ) {
        // Force redirect to 404 if not belongs to template
        next({ path: "/404" });
        return; // Make sure to return here so the rest of the function doesn't execute
    } else if (to.name === "hours" || to.name === "clinic-hours") {
        const isBetaReleaseEnabled = await checkRedirectBeta(
            to,
            "new_clinic_hours"
        );

        if (to.name === "hours" && !isBetaReleaseEnabled) {
            next({ name: "clinic-hours" });
            return;
        }

        if (to.name === "clinic-hours" && isBetaReleaseEnabled) {
            next({ name: "hours" });
            return;
        }
    }
    // Dynamically change the browser page title
    let defaultTitle = "DaySmart Vet";

    window.document.title =
        to.meta && to.meta.title ? to.meta.title : defaultTitle;

    next();
});

function checkRedirectBeta(to, key) {
    return axios({
        method: "get",
        headers: {
            "Vetter-Token": to.params.token
                ? to.params.token
                : localStorage.getItem("Vetter-Token"),
            "x-requested-with": "XMLHttpRequest"
        },
        url: `${process.env.BARRAMUNDI}account/is-feature-enabled?key=${key}`
    }).then(response => {
        const isClinicInBeta =
            response?.data?.response?.resource?.is_enabled === 1 ? true : false;

        return isClinicInBeta || to.query.forceview === "true";
    });
}

window.vuerouter = router;

window.routerNavigate = (event, url) => {
    event.preventDefault();
    window.vuerouter.push(url);
};

export default router;
